import { colors } from 'ui/theme';
import { Body2, Subtitle1 } from 'ui/theme/typography';
import { GoalDetailsPanel } from './GoalDetailsPanel';
import { DeletingStatusProps } from '../types';
import { TEST_IDS } from '../constants';
import {
  DeletingStatusContainer,
  LayoutWithPanel,
  MainContentLayout,
  MainLayoutWrapper,
} from './Styled';
import { StatusPageGoalCriteria } from './StatusPageGoalCriteria';
import { GoalDetailsPredictionSection } from './GoalDetailsPredictionSection';

const WE_ARE_DELETING_YOUR_PREDICTIVE_GOAL_CP = "We're deleting your predictive goal";
const MAY_TAKE_UP_TO_TEXT_CP =
  'It may take up to 24 hours to complete the deletion process. This goal will be removed from your Predicitive Goals list once completed.';

export const DeletingStatus = ({ goal }: DeletingStatusProps) => {
  return (
    <MainLayoutWrapper
      data-background-color={colors.backgroundSecondary}
      data-testid={TEST_IDS.DeletingPage}
    >
      <LayoutWithPanel>
        <GoalDetailsPanel goal={goal} showOnlyCoreDetails />
        <MainContentLayout>
          <StatusPageGoalCriteria goal={goal} />
          <GoalDetailsPredictionSection>
            <DeletingStatusContainer>
              <Subtitle1>{WE_ARE_DELETING_YOUR_PREDICTIVE_GOAL_CP}</Subtitle1>
              <Body2>{MAY_TAKE_UP_TO_TEXT_CP}</Body2>
            </DeletingStatusContainer>
          </GoalDetailsPredictionSection>
        </MainContentLayout>
      </LayoutWithPanel>
    </MainLayoutWrapper>
  );
};
